module.exports = __webpack_public_path__ + "static/img/wuzititle.e6712019.png";